<template>
    <v-container fluid class="pt-0">
        <v-row align="start" justify="center">
            <v-col cols="12" md="12" sm="12">
                <v-card class="elevation-4">
                    <v-card-title>
                        <v-row>
                            <v-col cols="2" sm="2" md="2" class="">
                                Employee List
                            </v-col>

                            <v-col cols="5" sm="5" md="5" class="text-center">
                                <v-btn @click="addRetailItem(business)" color="primary "  fab x-small dark class="mr-1" title="Add Retail Item">
                                    <v-icon>mdi-cart</v-icon>
                                </v-btn>


                                <v-btn @click="addFoodItem(business)" color="primary "  fab x-small dark class="mr-1" title="Add Food Item">
                                        <v-icon>mdi-food</v-icon>
                                </v-btn>
                                
                                <v-btn @click="addDrinkItem(business)" color="primary "  fab x-small dark class="mr-1" title="Add Drink Item"><v-icon>mdi-glass-mug</v-icon></v-btn>

                                <!-- <v-btn @click="addEmployee(id)" color="primary "  fab x-small dark class="mr-1" title="Add Employee"><v-icon>mdi-account-tie</v-icon></v-btn> -->

                                <v-btn @click="addDepartment(business)" color="primary "  fab x-small dark class="mr-1" title="Add Department"><v-icon>mdi-desktop-mac</v-icon></v-btn> 
                                          
                                <v-btn @click="addEvent(business)" color="primary " fab x-small dark class="mr-1" title="Add Event"><v-icon>mdi-calendar-plus</v-icon></v-btn>

                                <v-btn @click="editBusiness(business)" color="primary "  fab x-small dark class="mr-1" title="Business Edit">
                                    <v-icon>mdi-arrow-left</v-icon>
                                </v-btn> 

                            </v-col>    

                            <v-col cols="5" sm="5" md="5" class="text-center">
                                <v-row>
                                    <v-col cols="6" sm="6" md="6" class="text-center pt-0">    
                                        <div class="flex-grow-1"></div>
                                        <v-text-field
                                        v-model="search"
                                        append-icon="search"
                                        label="Search"
                                        single-line
                                        hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="6" sm="6" md="6" class="text-center pt-0">   

                                        <v-btn color="primary" class="ml-3" @click="$router.push({name:'createemployee',params:{business:business}})">Add Employee</v-btn>

                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>    
                    </v-card-title>
                    <v-card-text>
                        <v-divider></v-divider>
                        <v-data-table
                            :headers="headers"
                            :items="employees"
                            :items-per-page="20"
                            :search="search"
                            class="elevation-1">

                            <template v-slot:item.image="{ item }">
                              <!-- <v-avatar @click="editItem(item)" class="">
                                <img :src="item.image" :alt="item.title" />
                              </v-avatar> -->
                               <v-img :src="item.image" width="35" height="35" :alt="item.image" ></v-img> 
                            </template>

                            <template v-slot:item.action="{ item }">
                                                            <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
                                <v-icon small @click="deleteItem(item)">delete</v-icon>
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
    
</template>
<script >
import Vue from 'vue'
export default {
    data: () => ({
        search: "",
        headers: [
            { text: "Photo", value: "image", sortable: false },
            { text: "Name", value: "name" },
            { text: "Position", value: "designation" },
            { text: "Created At", value: "created_at" },
            { text: "Actions", value: "action", sortable: false }
        ],
        employees: [],
        business:0,
    }),
    created() {

         if (this.$route.params.business_id) {
        this.business = this.$route.params.business_id;
        }
      
      this.$http
      .get(this.$apidomain+"agent/employeeList/"+this.business)
      .then(res => {
          if(res.data.success==0)
          {
              this.$router.push({name:'businesslistnew'});
          }
       this.employees = res.data.employees;
      })
      .catch(err => {
        console.log(err.response);
      });
    },
     methods: 
    {
        editBusiness(id)
        {
            this.$router.push({name:'editbusiness',params:{id:id}});
        }, 
        addRetailItem(id)
        {
            this.$router.push({name:'retailitemlist',params:{business_id:id}});
        },

        addFoodItem(id)
        {
          //this.$router.push({name:'createitem',params:{business_id:id}});
          this.$router.push({name:'itemlist',params:{business_id:id}});
        },
        addDrinkItem(id)
        {
        this.$router.push({name:'drinkitemlist',params:{business_id:id}});
        },
        addEmployee(id)
        {
        this.$router.push({name:'employeelist',params:{business_id:id}});
        },
        addDepartment(id)
        {
        this.$router.push({name:'departmentlist',params:{business_id:id}});
        },
        addEvent(id)
        {
        this.$router.push({name:'eventlist',params:{business_id:id}});
        },
        editItem(item){
                this.$router.push({name:'editemployee',params:{id:item.id}});
            },
        deleteItem(item) {
                
            if (confirm("Are you sure you want to delete this Employee?")) {
                this.$http
            .post(this.$apidomain+"employeedelete/"+item.id)
            .then(res => {
                // //this.businesses = res.data.businesses;
                // this.$router.push("/itemlist/"+this.business);
                 this.$http
      .get(this.$apidomain+"employeeList/"+this.business)
      .then(res => {
       this.employees = res.data.employees;
      })
      .catch(err => {
        console.log(err.response);
      });
            })
            .catch(err => {
                console.log(err.response);
            });
            }
            },
   
  }
    
}
</script>